import { IGetVenueAddress } from 'src/api/getVenue/types';

const createAddressSummary = (address: IGetVenueAddress): string => {
  let summary = '';

  if (address?.address_line_1) summary = `${address.address_line_1},`;
  if (address?.address_town) summary = `${summary} ${address.address_town},`;
  if (address?.address_post_code) summary = `${summary} ${address.address_post_code}`;

  summary = summary.replace(/,\s*$/, '').trim(); // removes last comma or whitespace at start and end of string

  return summary;
};

export default createAddressSummary;
